/**
 * Format a phone number for display
 * Converts +14793464229 to (479) 346-4229
 * @param phone - Phone number in E.164 format (+1XXXXXXXXXX)
 * @returns Formatted phone number (XXX) XXX-XXXX
 */
export const formatPhoneNumber = (phone?: string): string => {
  if (!phone) return '';
  
  // Extract only digits
  const digits = phone.replace(/\D/g, '');
  
  // If it's 11 digits and starts with 1, remove the country code
  let cleanDigits = digits;
  if (digits.length === 11 && digits[0] === '1') {
    cleanDigits = digits.substring(1);
  }
  
  // If we have exactly 10 digits, format as (XXX) XXX-XXXX
  if (cleanDigits.length === 10) {
    return `(${cleanDigits.substring(0, 3)}) ${cleanDigits.substring(3, 6)}-${cleanDigits.substring(6)}`;
  }
  
  // Otherwise return the original
  return phone;
};

/**
 * Format a phone number for calling (keeps E.164 format)
 * @param phone - Phone number
 * @returns Phone number in E.164 format for tel: links
 */
export const formatPhoneForCall = (phone?: string): string => {
  if (!phone) return '';
  
  // If already in E.164 format, return as-is
  if (phone.startsWith('+')) {
    return phone;
  }
  
  // Extract digits and add +1 if needed
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 10) {
    return `+1${digits}`;
  }
  if (digits.length === 11 && digits[0] === '1') {
    return `+${digits}`;
  }
  
  return phone;
};

